import { cloneDeep } from 'lodash-es';
import Utils from '../../../util';
import { DisplayOption } from '../../results/baseline/baseline-summary-display-option/baseline-summary-display-option.model';

export interface ResultRowInterface {
  'RESULTS.DATA.LABEL'?: string;
  'RESULTS.DATA.VALUES'?: number[];
  'RESULTS.DATA.UNIT'?: string | null;
  retainPeriod?: boolean;
  formatValues?: string[];
  'aux.DisplayOption'?: DisplayOption;
  'RESULTS.GENERAL.SHARE'?: string;
  'RESULTS.GENERAL.AVERAGE'?: number;
  'RESULTS.GENERAL.COST'?: number;
}

export class ResultRow {
  'RESULTS.DATA.LABEL': string;
  'RESULTS.DATA.VALUES': number[];
  'RESULTS.DATA.UNIT': string | null;
  retainPeriod?;
  formatValues?;
  'aux.DisplayOption'?: DisplayOption;
  'RESULTS.GENERAL.SHARE'?: string;
  'RESULTS.GENERAL.AVERAGE'?: number;
  'RESULTS.GENERAL.COST'?: number;

  get label() {
    return this['RESULTS.DATA.LABEL'];
  }
  set label(value: string) {
    this['RESULTS.DATA.LABEL'] = value;
  }
  get values() {
    return this['RESULTS.DATA.VALUES'];
  }
  set values(value: number[]) {
    this['RESULTS.DATA.VALUES'] = value;
  }
  get unit() {
    return this['RESULTS.DATA.UNIT'];
  }
  set unit(value: string | null) {
    this['RESULTS.DATA.UNIT'] = value;
  }

  constructor(param: ResultRowInterface = {}) {
    this['RESULTS.DATA.LABEL'] = param['RESULTS.DATA.LABEL'] ?? '';
    this['RESULTS.DATA.VALUES'] = Utils.deepCopy(param['RESULTS.DATA.VALUES']) ?? [];
    this['RESULTS.DATA.UNIT'] = param['RESULTS.DATA.UNIT'] ?? null;
    if (param.retainPeriod) {
      this.retainPeriod = param.retainPeriod;
    }
    if (param.formatValues) {
      this.formatValues = param.formatValues;
    }
    if (param['aux.DisplayOption']) {
      this['aux.DisplayOption'] = param['aux.DisplayOption'];
    }
    if (param['RESULTS.GENERAL.SHARE']) {
      this['RESULTS.GENERAL.SHARE'] = param['RESULTS.GENERAL.SHARE'];
    }
    if (param['RESULTS.GENERAL.AVERAGE']) {
      this['RESULTS.GENERAL.AVERAGE'] = param['RESULTS.GENERAL.AVERAGE'];
    }
    if (param['RESULTS.GENERAL.COST']) {
      this['RESULTS.GENERAL.COST'] = param['RESULTS.GENERAL.COST'];
    }
  }

  deepCopy() {
    return new ResultRow(cloneDeep(this));
  }
}
